// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__3FUM8","loader":"Preloader_loader__28BcO","load":"Preloader_load__3odh4"};